"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modelFactory;

var _modelUtil = _interopRequireDefault(require("@leverege/model-util"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function modelFactory(options) {
  const {
    vehicleTypes
  } = options;
  const TYPE = 'recovr.AlertModel';

  function create(type, extend = {}) {
    return {
      type: `recovr.alert.${type}`,
      vehicleTypes: createDefaultVehicleTypes(),
      ...extend
    };
  }

  function createDefaultVehicleTypes() {
    return vehicleTypes.reduce((prev, curr) => {
      prev[curr.toLowerCase()] = false; // eslint-disable-line no-param-reassign

      return prev;
    }, {});
  }

  function createDefaultVehicleAccessors() {
    return vehicleTypes.reduce((prev, curr) => {
      return { ...prev,
        ..._modelUtil.default.createAllValue(`vehicleTypes/${curr.toLowerCase()}`, `${curr}Active`, {
          defaultValue: false
        })
      };
    }, {});
  }

  function createDefaultAccessors() {
    return { ..._modelUtil.default.createAllValue('active', 'Active', undefined, {
        defaultValue: false
      }),
      ..._modelUtil.default.createAllValue('threshold', 'Threshold', undefined, {
        defaultValue: 25
      }),
      ...createDefaultVehicleAccessors()
    };
  }

  function hasActiveAlerts(model) {
    return Object.keys(model.vehicleTypes).some(key => model.vehicleTypes[key] === true) || model.active === true;
  }

  return {
    TYPE,
    create,
    ...createDefaultAccessors(),
    vehicleTypes,
    hasActiveAlerts
  };
}